import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 * Instance of the Film Context component for providing to children and for children to consume.
 */
export const FilmContextInstance = createEmptyContext();
